export default "__VITE_ASSET__44d2ecd2__"